import AxiosService from '../AxiosService';
// Stock Notifications
const getStockNotifications = async () => {
  try {
    const instance = AxiosService.createAuthAxiosInstance();
    const response = await instance.get('/v1/client/my-stock-notifications');
    return response.data;
  } catch (error) {
    console.log('Erro ao buscar notificações de estoque:', error);
    throw error;
  }
};

const createStockNotification = async (sku: string, descricao: string) => {
  try {
    const instance = AxiosService.createAuthAxiosInstance();
    const response = await instance.post('/v1/client/create-stock-notification', {
      sku: sku,
      descricao: descricao,
    });
    return response.data;
  } catch (error) {
    console.log('Erro ao criar notificação de estoque:', error);
    throw error;
  }
};

const removeStockNotification = async (id: number) => {
  try {
    const instance = AxiosService.createAuthAxiosInstance();
    const response = await instance.delete(
      `/v1/client/remove-stock-notification/${id}`,
    );
    return response.data;
  } catch (error) {
    console.log('Erro ao remover notificação de estoque:', error);
    throw error;
  }
};

export default {
  getStockNotifications,
  createStockNotification,
  removeStockNotification,
};
